import pick from 'lodash/pick';

export const decodeQueryString = (queryString) => (
  queryString.substr(1).trim().split('&')
    .filter((it) => it)
    .map((pairString) => pairString.split('=').map(window.decodeURIComponent))
    .reduce((acc, [key, value]) => (
      { ...acc, [key]: value || null }
    ), {})
);

export const encodeQueryString = (queryObject) => {
  const keys = Object.keys(queryObject);
  if (keys.length > 0) {
    const pairStrings = keys.map((key) => (
      `${key}=${queryObject[key] ? encodeURIComponent(queryObject[key]) : ''}`
    ));
    return `?${pairStrings.join('&')}`;
  }
  return '';
};

export const mergeQueryStringAndQueryObject = (queryString, queryObject) => (
  encodeQueryString({ ...decodeQueryString(queryString), ...queryObject })
);

export const whitelistQueryString = (search, whitelist = ['filter', 'speciesFilter']) => (
  encodeQueryString(pick(decodeQueryString(search), whitelist))
);
